export enum MediaControllerState {
    Initializing = 'Initializing',
    Idle = 'idle',
    Buffering = 'buffering',
    Playing = 'playing',
    Paused = 'paused',
    Loading = 'loading',
    Disposing = 'disposing',
    Error = 'Error'
}
